export const CREATE_CANVAS = 'CREATE_CANVAS'
export const DISPOSE_CANVAS = 'DISPOSE_CANVAS'

export const EDIT_IMAGE = "EDIT_IMAGE";
export const CANCEL_EDIT_IMAGE = "CANCEL_EDIT_IMAGE";

export const TOGGLE_EDITOR_TOOLBAR = "TOGGLE_EDITOR_TOOLBAR";

export const SET_SELECTED_TOOL = "SET_SELECTED_TOOL";

export const SET_CANVAS_STATE = "SET_CANVAS_STATE";

export const START_DRAWING_LINE = "START_DRAWING_LINE";
export const STOP_DRAWING_LINE = "STOP_DRAWING_LINE";

export const DELETE_SELECTED_ITEMS = "DELETE_SELECTED_ITEMS";

export const SAVE_CANVAS = "SAVE_CANVAS";
export const SAVE_CANVAS_REQUEST = "SAVE_CANVAS_REQUEST";
export const SAVE_CANVAS_SUCCESS = "SAVE_CANVAS_SUCCESS";
export const SAVE_CANVAS_ERROR = "SAVE_CANVAS_ERROR";


export const createCanvas = (file, elementId, width, height) => {
    return { type: CREATE_CANVAS,  payload: { elementId, file, width, height } };
}

export const disposeCanvas = (elementId) => {
    return { type: DISPOSE_CANVAS,  payload: { elementId } };
}

export const editImage = (file, inspectionId, visitId) => {
    return {
        type: EDIT_IMAGE,
        payload: {
            file,
            inspectionId,
            visitId
        },
    };
}

export const cancelEditImage = () => {
    return { type: CANCEL_EDIT_IMAGE };
}

export const toggleEditorToolbar = () => {
    return {type: TOGGLE_EDITOR_TOOLBAR }
}

export const setSelectedTool = (tool) => {
    return {type: SET_SELECTED_TOOL, payload: {tool} }
}

export const startDrawingLine = (line) => {
    return {type: START_DRAWING_LINE, payload: {line} }
}

export const stopDrawningLine = (line) => {
    return {type: STOP_DRAWING_LINE }
}

export const deleteSelectedItems = (line) => {
    return {type: DELETE_SELECTED_ITEMS }
}

export const saveCanvas = () => {
    return { type: 'SAVE_CANVAS' }
}

export const saveCanvasRequest = (inspectionId, visitId, imageId, formData) => {
    return {
        type: 'CALL_API',
        types: [SAVE_CANVAS_REQUEST, SAVE_CANVAS_SUCCESS, SAVE_CANVAS_ERROR],
        path: `api/canvas/${inspectionId}/${visitId}/${imageId}`,
        method: 'post',
        payload: {
            formData
        },
    };
}


// WEBPACK FOOTER //
// ./src/modules/vegetation/actions/editor.js